import { ObservableItemIdentifier } from '../../../api-contracts/other/ObservableItemIdentifier';

const { UndercarriageChangeOut } =
  ObservableItemIdentifier.Identifiers.Operation;

/**
 * Paths cleared when a changeout checkbox is UNTICKED (the
 * CheckboxWithComponents contract: unchecking removes its childPaths).
 *
 * History (bug-hunt, 26 Aug 2026): Left shipped childPaths={[]} so a
 * RETRACTED changeout kept - and synced - its date and machine hours, which
 * feed undercarriage-hours anchoring downstream; Right "cleared" through
 * 'Operation.UndercarriagePropelHours.Right.Changeout', an identifier that
 * does not exist in the vocabulary. Pinned by OperatingHoursChangeout.test:
 * both sides non-empty, mirrored, and every path present in the vocabulary.
 */
export const CHANGEOUT_CHILD_PATHS = {
  left: [
    UndercarriageChangeOut.Left.Date,
    UndercarriageChangeOut.Left.MachineHoursAtChange,
  ],
  right: [
    UndercarriageChangeOut.Right.Date,
    UndercarriageChangeOut.Right.MachineHoursAtChange,
  ],
} as const;
